// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"ScrollArea_scrollbar__u_eWj","thumb":"ScrollArea_thumb__We0cx","corner":"ScrollArea_corner__q36DS"};